import React, { useState } from 'react';
import { gmailLogo, appleLogo, metamaskLogo, loader } from '../../assets';

interface IAuthButtonsProps {
  onContinueWithGoogle: () => void;
  onContinueWithApple: () => void;
  onContinueWithMetamask: () => void;
}

const AuthButtons: React.FC<IAuthButtonsProps> = ({
  onContinueWithGoogle,
  onContinueWithApple,
  onContinueWithMetamask,
}) => {
  // Individual loading states for each button
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const [isAppleLoading, setIsAppleLoading] = useState(false);
  const [isMetamaskLoading, setIsMetamaskLoading] = useState(false);

  // Handler for Google login with loading state
  const handleGoogleLogin = () => {
    setIsGoogleLoading(true);
    // Call the original handler
    onContinueWithGoogle();
    
    // Set a timeout to reset the loading state if the process takes too long
    // This ensures the button doesn't stay in loading state forever if there's an error
    setTimeout(() => {
      setIsGoogleLoading(false);
    }, 20000); // 20-second timeout
  };

  // Handler for Apple login with loading state
  const handleAppleLogin = () => {
    setIsAppleLoading(true);
    // Call the original handler
    onContinueWithApple();
    
    // Set a timeout to reset the loading state if the process takes too long
    setTimeout(() => {
      setIsAppleLoading(false);
    }, 20000); // 20-second timeout
  };

  // Handler for Metamask login with loading state
  const handleMetamaskLogin = () => {
    setIsMetamaskLoading(true);
    // Call the original handler
    onContinueWithMetamask();
    
    // Set a timeout to reset the loading state if the process takes too long
    setTimeout(() => {
      setIsMetamaskLoading(false);
    }, 20000); // 20-second timeout
  };

  return (
    <section className="w-full max-w-[360px] mx-auto mt-6 sm:mt-8">
      <button
        className="btn-text w-full rounded-[6px] border border-[#E2E8F0] h-12 text-sm sm:text-base relative"
        onClick={handleGoogleLogin}
        disabled={isGoogleLoading}
      >
        {isGoogleLoading ? (
          <>
            <img src={loader} alt="loading" className="w-5 h-5 mr-3 animate-spin" />
            <span className="animate-pulse">Connecting with Google...</span>
          </>
        ) : (
          <>
            <img src={gmailLogo} alt="gmail-logo" className="w-5 h-5 mr-3" />
            Continue with Google
          </>
        )}
      </button>
      <button
        className="btn-text w-full mt-3 sm:mt-4 rounded-[6px] border border-[#E2E8F0] h-12 text-sm sm:text-base"
        onClick={handleAppleLogin}
        disabled={isAppleLoading}
      >
        {isAppleLoading ? (
          <>
            <img src={loader} alt="loading" className="w-5 h-5 mr-3 animate-spin" />
            <span className="animate-pulse">Connecting with Apple...</span>
          </>
        ) : (
          <>
            <img src={appleLogo} alt="apple-logo" className="w-5 h-5 mr-3" />
            Continue with Apple
          </>
        )}
      </button>
      <button
        className="btn-text w-full mt-3 sm:mt-4 rounded-[6px] border border-[#E2E8F0] h-12 text-sm sm:text-base"
        onClick={handleMetamaskLogin}
        disabled={isMetamaskLoading}
      >
        {isMetamaskLoading ? (
          <>
            <img src={loader} alt="loading" className="w-5 h-5 mr-3 animate-spin" />
            <span className="animate-pulse">Connecting with MetaMask...</span>
          </>
        ) : (
          <>
            <img src={metamaskLogo} alt="metamask-logo" className="w-5 h-5 mr-3" />
            Continue with MetaMask
          </>
        )}
      </button>
    </section>
  );
};

export default AuthButtons;